<template>
  <div class="app-main-content">
    <div class="statistics-card">
      <div class="stat-item stat-item-primary">
        <span class="stat-value">{{ statistics.continuousBondCount }}</span>
        <span class="stat-label">有效年度Bond</span>
      </div>
      <div class="stat-item stat-item-warning">
        <span class="stat-value">{{ statistics.expiringBondCount }}</span>
        <span class="stat-label">30天内到期Bond</span>
      </div>
      <div class="stat-item stat-item-danger">
        <span class="stat-value">{{ statistics.expiredBondCount }}</span>
        <span class="stat-label">已过期Bond</span>
      </div>
      <div class="stat-item stat-item-info">
        <span class="stat-value">{{ statistics.stbBondCount }}</span>
        <span class="stat-label">STB单次Bond</span>
      </div>
    </div>

    <div class="search-form">
      <el-form :inline="true" :model="searchForm" class="search-form-inline">
        <el-form-item label="进口商名称">
          <el-input v-model="searchForm.importerName" placeholder="请输入进口商名称" clearable />
        </el-form-item>
        <el-form-item label="Importer No">
          <el-input v-model="searchForm.importerNo" placeholder="请输入Importer No" clearable />
        </el-form-item>
        <el-form-item label="Bond编号">
          <el-input v-model="searchForm.bondNo" placeholder="请输入Bond编号" clearable />
        </el-form-item>
        <el-form-item label="Bond类型">
          <el-select v-model="searchForm.bondType" placeholder="请选择" clearable>
            <el-option label="年度Continuous Bond" value="1" />
            <el-option label="单次STB Bond" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable multiple collapse-tags>
            <el-option label="未生效" value="1" />
            <el-option label="生效" value="2" />
            <el-option label="到期预警" value="3" />
            <el-option label="已过期" value="4" />
            <el-option label="作废" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="海关核验">
          <el-select v-model="searchForm.customsVerify" placeholder="请选择" clearable multiple collapse-tags>
            <el-option label="未核验" value="1" />
            <el-option label="已核验有效" value="2" />
            <el-option label="编号无效" value="3" />
            <el-option label="过期" value="4" />
            <el-option label="额度不足" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增Bond</el-button>
      <el-button icon="el-icon-view" @click="handleBatchVerify">批量海关核验</el-button>
      <el-button icon="el-icon-delete" @click="handleBatchInvalid">批量作废</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      class="bond-management-hover"
      style="width: 100%"
      row-key="uuid"
      :row-style="tableRowStyle"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true" />
      <el-table-column prop="importerName" label="进口商名称" />
      <el-table-column prop="importerNo" label="Importer No" />
      <el-table-column prop="bondNo" label="Bond编号" />
      <el-table-column prop="bondTypeName" label="Bond类型" />
      <el-table-column prop="guarantor" label="担保公司/人" />
      <el-table-column prop="bondAmount" label="Bond金额(USD)" />
      <el-table-column prop="effectiveExpiryDate" label="生效/到期" />
      <el-table-column prop="statusName" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.statusName" :type="getStatusTagType(scope.row.status)" size="small">{{ scope.row.statusName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="customsVerifyName" label="海关核验">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.customsVerifyName" :type="getCustomsVerifyTagType(scope.row.customsVerify)" size="small">{{ scope.row.customsVerifyName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <div class="operation-buttons">
            <el-button size="mini" @click="handleEdit(scope.row)" v-if="scope.row.status !== '5'">编辑</el-button>
            <el-button size="mini" @click="handleLog(scope.row)">Bond日志</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="pagination.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <bond-form ref="bondForm" @save-success="handleSaveSuccess" />

    <customs-verify-modal ref="customsVerifyModal" @verify-success="handleVerifySuccess" />

    <bond-log-modal ref="bondLogModal" />

    <el-dialog title="确认作废" :visible.sync="invalidDialogVisible" width="400px">
      <p>确认作废 {{ selectedData.length }} 条Bond？此操作不可恢复</p>
      <span slot="footer">
        <el-button @click="invalidDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmInvalid">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BondForm from './components/bondManagement/BondForm'
import CustomsVerifyModal from './components/bondManagement/CustomsVerifyModal'
import BondLogModal from './components/bondManagement/BondLogModal'
import { getBondList, getBondStatistics, saveBond, updateBond, batchVerify, batchInvalid } from '@/api/bondManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'BondManagement',
  components: {
    BondForm,
    CustomsVerifyModal,
    BondLogModal
  },
  data() {
    return {
      searchForm: {
        importerName: '',
        importerNo: '',
        bondNo: '',
        bondType: '',
        status: [],
        customsVerify: []
      },
      tableData: [],
      statistics: {
        continuousBondCount: 0,
        expiringBondCount: 0,
        expiredBondCount: 0,
        stbBondCount: 0
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      selectedData: [],
      invalidDialogVisible: false
    }
  },
  mounted() {
    this.loadData()
    this.loadStatistics()
  },
  methods: {
    async loadData() {
      const loading = getLoading4Cxt(this)
      try {
        const params = {
          importerName: this.searchForm.importerName,
          importerNo: this.searchForm.importerNo,
          bondNo: this.searchForm.bondNo,
          bondType: this.searchForm.bondType,
          status: Array.isArray(this.searchForm.status) ? this.searchForm.status.join(',') : '',
          customsVerify: Array.isArray(this.searchForm.customsVerify) ? this.searchForm.customsVerify.join(',') : '',
          pageNum: this.pagination.pageNum - 1,
          pageSize: this.pagination.pageSize
        }
        const res = await getBondList(params)
        const pageInfo = res.data || {}
        this.tableData = pageInfo.list || []
        this.pagination.total = pageInfo.total || 0
      } finally {
        loading.close()
      }
    },
    tableRowStyle({ row }) {
      const isSelected = this.selectedData.some(item => item.uuid === row.uuid)
      return isSelected ? { backgroundColor: '#ecf5ff' } : {}
    },
    async loadStatistics(params) {
      try {
        const res = await getBondStatistics(params)
        const data = res.data || {}
        this.statistics = {
          continuousBondCount: data.continuousBondCount || 0,
          expiringBondCount: data.expiringBondCount || 0,
          expiredBondCount: data.expiredBondCount || 0,
          stbBondCount: data.stbBondCount || 0
        }
      } catch (e) {
        console.error(e)
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
      this.loadStatistics({
        importerName: this.searchForm.importerName,
        importerNo: this.searchForm.importerNo,
        bondNo: this.searchForm.bondNo,
        bondType: this.searchForm.bondType,
        status: Array.isArray(this.searchForm.status) ? this.searchForm.status.join(',') : '',
        customsVerify: Array.isArray(this.searchForm.customsVerify) ? this.searchForm.customsVerify.join(',') : ''
      })
    },
    handleReset() {
      this.searchForm = {
        importerName: '',
        importerNo: '',
        bondNo: '',
        bondType: '',
        status: [],
        customsVerify: []
      }
      this.pagination.pageNum = 1
      this.loadData()
      this.loadStatistics()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    handleSelectionChange(val) {
      this.selectedData = val
    },
    handleAdd() {
      this.$refs.bondForm.show('add')
    },
    handleEdit(row) {
      this.$refs.bondForm.show('edit', row)
    },
    handleLog(row) {
      this.$refs.bondLogModal.show(row.uuid, row.bondNo)
    },
    handleBatchVerify() {
      if (this.selectedData.length === 0) {
        this.$message.warning('请选择需要海关核验的数据')
        return
      }
      this.$refs.customsVerifyModal.show(this.selectedData)
    },
    handleBatchInvalid() {
      if (this.selectedData.length === 0) {
        this.$message.warning('请选择需要作废的Bond')
        return
      }
      this.invalidDialogVisible = true
    },
    async confirmInvalid() {
      const loading = getLoading4Cxt(this)
      try {
        const uuids = this.selectedData.map(item => item.uuid)
        await batchInvalid(uuids)
        this.$message.success('作废成功')
        this.invalidDialogVisible = false
        this.loadData()
        this.loadStatistics()
      } finally {
        loading.close()
      }
    },
    handleSaveSuccess() {
      this.loadData()
      this.loadStatistics()
    },
    handleVerifySuccess() {
      this.loadData()
    },
    getStatusTagType(status) {
      const typeMap = {
        '1': 'info',
        '2': 'success',
        '3': 'warning',
        '4': 'danger',
        '5': 'info'
      }
      return typeMap[status] || 'info'
    },
    getCustomsVerifyTagType(customsVerify) {
      const typeMap = {
        '1': 'info',
        '2': 'success',
        '3': 'danger',
        '4': 'danger',
        '5': 'warning'
      }
      return typeMap[customsVerify] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-card {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  .stat-item {
    flex: 1;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    .stat-value {
      font-size: 28px;
      font-weight: bold;
      color: #333;
    }
    .stat-label {
      display: block;
      margin-top: 8px;
      color: #999;
    }
  }
  .stat-item-primary .stat-value {
    color: #409EFF;
  }
  .stat-item-warning .stat-value {
    color: #E6A23C;
  }
  .stat-item-danger .stat-value {
    color: #F56C6C;
  }
  .stat-item-info .stat-value {
    color: #909399;
  }
}

.search-form {
  background: #fff;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  .search-form-inline {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .el-form-item {
        margin-right: 6px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
      .el-form-item__label {
        float: none;
        display: flex;
        align-items: center;
        line-height: 32px;
        padding: 0 4px 0 0;
        font-size: 13px;
      }
      .el-form-item__content {
        line-height: 32px;
        .el-input,
        .el-select {
          width: 110px;
        }
      }
    }
  }
}

.toolbar {
  margin-bottom: 16px;
}

.operation-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

<style lang="scss">
.bond-management-hover .el-table__body-wrapper tbody tr:hover > td {
  background-color: #f5f7fa !important;
}
</style>
